import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react3'
import ProductDisplayPrice from '../../../../components/product-display-price'
import DisplayPrice from '../../../../leap/components/display-price/index.jsx'
import AddToCartBtn from './ctas/add-to-cart'
import NotifyMeBtn from './ctas/notify-me'
import OpenConfiguratorBtn from './ctas/open-configurator'
import BabyListBtn from './ctas/baby-list'
import {useKindlyChat} from '../../../../components/kindly-chat'
import {useZendeskChat} from '../../../../components/zendesk-chat'
import useBreakpoints from '../../../../hooks/use-breakpoints'

const StickyBar = ({viewModel}) => {
    const kindlyApi = useKindlyChat()
    const zendeskApi = useZendeskChat()
    const offset = useBreakpoints({base: '6rem', sm: 0})

    useEffect(() => {
        kindlyApi?.setBottomOffset(offset)
        zendeskApi?.setBottomOffset(offset)
    }, [kindlyApi, zendeskApi, offset])

    if (!viewModel.ecommerceEnabled) {
        return null
    }

    const {product} = viewModel
    let stickyButtons

    if (product.c_displayTemplate === 'xpdp-configurator') {
        stickyButtons = (
            <>
                <OpenConfiguratorBtn
                    size="md"
                    disabled={!product?.c_configuratorConfig}
                    onClick={viewModel.openConfigurator.onClick}
                    width="auto"
                    flex="1 0 auto"
                />
                {product.isOrderable ? (
                    <AddToCartBtn
                        showLabel={false}
                        flex="0 0 auto"
                        product={product}
                        isLoading={viewModel.isLoading}
                        onClick={viewModel.addToCart.onClick}
                    />
                ) : (
                    <NotifyMeBtn
                        onClick={viewModel.notifyMe.onClick}
                        showLabel={false}
                        flex="0 0 auto"
                    />
                )}
            </>
        )
    } else if (viewModel.babyList.enabled) {
        stickyButtons = (
            <>
                {product.isOrderable ? (
                    <AddToCartBtn
                        size="md"
                        product={product}
                        isLoading={viewModel.isLoading}
                        onClick={viewModel.addToCart.onClick}
                        flex="1 0 auto"
                    />
                ) : (
                    <NotifyMeBtn onClick={viewModel.notifyMe.onClick} size="md" flex="1 0 auto" />
                )}
                <BabyListBtn
                    product={product}
                    onClick={viewModel.babyList.onClick}
                    flex="0 0 auto"
                    showLabel={false}
                />
            </>
        )
    } else if (product.isOrderable) {
        stickyButtons = (
            <AddToCartBtn
                size="md"
                product={product}
                isLoading={viewModel.isLoading}
                onClick={viewModel.addToCart.onClick}
                flex="1 0 auto"
            />
        )
    } else {
        stickyButtons = (
            <NotifyMeBtn onClick={viewModel.notifyMe.onClick} size="md" flex="1 0 auto" />
        )
    }

    return (
        <Box
            py="spacing-12"
            px="spacing-24"
            display="flex"
            flexDirection="row"
            gap="spacing-8"
            borderWidth="1px"
            borderColor="background.section.strong"
            bg="primary.base.white"
            alignItems="center"
        >
            <Box flexShrink={1} minWidth={0}>
                <ProductDisplayPrice
                    as={DisplayPrice}
                    product={product}
                    loading={viewModel.isLoading}
                    showVatLabel={true}
                    size="md"
                />
            </Box>
            <Box
                display="flex"
                flexDirection="row"
                gap="spacing-8"
                marginLeft="auto"
                flexShrink={0}
            >
                {stickyButtons}
            </Box>
        </Box>
    )
}

StickyBar.propTypes = {
    viewModel: PropTypes.object
}

export default StickyBar
